import { render, staticRenderFns } from "./RoleConfigWindow.vue?vue&type=template&id=29731930&scoped=true&"
import script from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
export * from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
import style0 from "./RoleConfigWindow.vue?vue&type=style&index=0&id=29731930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29731930",
  null
  
)

export default component.exports